import React from 'react';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';

function ResetTaskModal({ onConfirm, onCancel, taskId }) {
    return (
        <div className='modal-container' style={{height:"220px", maxWidth:"480px"}}>
            <button className='modal-close-button' onClick={onCancel}><Cross2Icon width='30px' height='30px'/></button>
            <div className='modal-header'>Reset Task</div>
            <div className='modal-content'>
                <div style={{fontSize:'18px'}}>Are you sure you want to reset this task?</div>
                {taskId && (
                    <div style={{marginTop:'6px', fontSize:'14px'}}>Task ID: {taskId}</div>
                )}
            </div>
            <div className="modal-footer">
                <button className="button" style={{width:'100px', marginRight:'10px'}} onClick={onCancel}>Cancel</button>
                <button className="button" style={{width:'100px'}} onClick={onConfirm}>Yes</button>
            </div>
        </div>
    );
}

export default ResetTaskModal;
